import { render } from "./FooterSmall.vue?vue&type=template&id=d5861c84"
import script from "./FooterSmall.vue?vue&type=script&lang=js"
export * from "./FooterSmall.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yaakovbeckerman/projects/vue-notus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__